module.exports = "<div id=\"map-details\" \n     style=\"width: 100%;\n            height: 100%;\"\n></div>"